import ProductShadowBase from "../productShadowBase";
import CatEntry from "./Entry";

export default class CatEntryElement extends ProductShadowBase {
  connectedCallback() {
    this.loadAndRender(() => (
      <CatEntry
        backendHost={this.backendHost ?? undefined}
        appPathPrefix={this.appPathPrefix ?? undefined}
        skipCart={this.skipCart}
        channel={this.channel ?? undefined}
        language={this.language ?? undefined}
      />
    ));
  }
}
